import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
import { ILeverageTokenInfoSummaryViewModel } from "../leverage-token-info-summary/leverage-token-info-summary.interface";

const initialSate: ILeverageTokenInfoSummaryViewModel = {
	currentLeverage: null,
	baseSymbol: null,
	fiat: null,
	tradableId: null,
	basePrice: null,
	overnightFee: null,
	desiredLeverage: null,
	isLong: null,
	tradable: null,
	releverageTime: null
};

@Injectable({
	providedIn: "root"
})
export class LeverageTokenInfoState extends StateService<ILeverageTokenInfoSummaryViewModel> {
	public constructor() {
		super(initialSate);
	}

	public resetInfo(): void {
		this.setState(initialSate);
	}

	public updateInfo(info: ILeverageTokenInfoSummaryViewModel): void {
		this.setState(info);
	}

	public getInfo$(): Observable<ILeverageTokenInfoSummaryViewModel> {
		return this.select((state) => state);
	}
}
